export const testimonialsArray = [
  {
    name: 'John D.',
    date: 'March 1, 2025',
    review:
      'Mistress Sammi is truly one-of-a-kind. Her dominance and presence are unmatched. A life-changing experience!',
  },
  {
    name: 'Michael R.',
    date: 'February 20, 2025',
    review:
      'Every session with Mistress Sammi is intense and fulfilling. She knows exactly how to push my limits!',
  },
  {
    name: 'Steve P.',
    date: 'January 10, 2025',
    review:
      'I was completely mesmerized by her control and elegance. Her sessions are beyond extraordinary!',
  },
  {
    name: 'David L.',
    date: 'March 10, 2025',
    review:
      'Mistress Sammi’s ability to command and dominate is unparalleled. I left the session feeling completely transformed.',
  },
  {
    name: 'Chris M.',
    date: 'February 5, 2025',
    review:
      'An experience like no other! Her expertise and intuition make every session uniquely thrilling.',
  },
  {
    name: 'Robert K.',
    date: 'January 25, 2025',
    review:
      'I’ve never felt such a perfect balance of control and care. Mistress Sammi is truly exceptional!',
  },
];
